import axios from 'axios';

export const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('zeezo_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const path = window.location.pathname;
      if (path !== '/' && path !== '/login' && path !== '/signup') {
        localStorage.removeItem('zeezo_token');
        localStorage.removeItem('zeezo_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
